import {r as d, l as load} from '@theme/theme-sections';
import {s as u} from '@theme/section-slider-lifecycle';
import {loadCarouselDependencies} from '@theme/carousel-dependencies';
const a = 'product-recommendations';
var o, l, c;
const f =
    ((c = (l = (o = window.Shopify) == null ? void 0 : o.theme) == null ? void 0 : l.sections) == null
      ? void 0
      : c.registered) || {},
  S = typeof f[a] > 'u',
  n = {slider: '[data-slider]', productItem: '.recommended-products__product-list-item', progressBar: '[data-slider-progress-bar]'};
S &&
  d(a, {
    ...u,
    onLoad() {
      this.teardown(),
        (this.sectionActive = !0),
        (this.slider = null),
        (this.elements = {section: this.container.closest('.shopify-section') || this.container});
      this.listenForSliderDemand();
      loadCarouselDependencies({progress: true}).catch(error => {
        if (this.isSectionActive()) console.warn('Could not preload carousel:', error);
      });
      this.loadRecommendedProducts();
    },
    initSlider() {
      if (!this.isSectionActive() || !this.container.querySelector(n.slider)?.querySelector(n.productItem)) return;
      return this.withSliderDependencies(dependencies => this.createSlider(dependencies));
    },
    createSlider({Flickity: h, SliderProgressIndicator: m}) {
      const e = this.container.querySelector(n.slider);
      if (!this.isSectionActive() || !e) return;
      this.destroySlider(),
        (this.slider = new h(e, {
          prevNextButtons: !0,
          pageDots: !1,
          cellAlign: 'left',
          contain: !0,
          watchCSS: !1,
          arrowShape: 'M62.5 77.6517L34.8484 50L62.5 22.3484L65.1517 25L40.1517 50L65.1517 75L62.5 77.6517Z',
        }));
      const r = this.container.querySelector(n.progressBar);
      r && (this.progressIndicator = new m({element: r, slider: this.slider})), this.scheduleSliderResize();
    },
    loadRecommendedProducts() {
      this.sliderRequest = null;
      this.container.setAttribute('aria-busy', 'true');
      var r;
      (r = this.requestController) == null || r.abort(),
        cancelAnimationFrame(this.initFrame),
        (this.initFrame = null),
        this.destroySlider(),
        (this.requestController = new AbortController());
      const e = this.requestController;
      fetch(this.container.dataset.url, {signal: e.signal})
        .then((t) => {
          if (!t.ok) throw new Error(`Could not load product recommendations: ${t.status}`);
          return t.text();
        })
        .then((t) => {
          if (!this.isSectionActive() || e !== this.requestController) return;
          const s = document.createElement('div');
          s.innerHTML = t;
          const i = s.querySelector(`[data-section-id="${this.id}"]`),
            slider = i == null ? void 0 : i.querySelector(n.slider);
          this.container.setAttribute('aria-busy', 'false');
          if (!slider?.querySelector(n.productItem)) {
            this.hideSection();
            return;
          }
          this.showSection(), (this.container.innerHTML = i.innerHTML), this.initSlider();
        })
        .catch((t) => {
          if (t.name !== 'AbortError' && this.isSectionActive() && e === this.requestController) {
            console.warn(t);
            this.container.setAttribute('aria-busy', 'false');
            this.hideSection();
          }
        })
        .finally(() => {
          e === this.requestController && (this.requestController = null);
        });
    },
  });
// Also load the first instance inserted after the theme editor has initialised.
load(a);
